<template>
	<div style="background: #f3f4f7" v-loading.fullscreen.lock="fullscreenLoading">
		<userHeader />
		<crumbs :txt="a" type="2" :ljList="ljList" @hdBtn="hdBtn" :crumFlag="crumFlag" height="53px" />
		<div class="meiWecBox">
			<div class="gudBtns">
				<div class="gudBtnItem gudBack supHove3" @click="hdBtn">
					<img src="@/assets/img/back.svg" alt="" />
					<span>返回</span>
				</div>
				<div class="gudBtnItem supHove3" v-if="type == 4" @click="hqFn">
					<img src="@/assets/img/sc (3).svg" alt="" />
					<span>获得本片</span>
				</div>
				<div class="gudBtnItem supHove3" @click="scFn(perData)" :class="perData.isCollect ? 'activeBtn' : ''">
					<img src="@/assets/img/sc (4).svg" v-if="!perData.isCollect" alt="" />
					<img src="@/assets/img/sc (2).svg" v-if="perData.isCollect" alt="" />
					<span>{{ perData.isCollect ? '已收藏' : '收藏' }}</span>
				</div>
				<div class="gudBtnItem supHove3" v-if="type == 2 && flags == 1">
					<img src="@/assets/img/形状备份.png" @click="xzBtns" alt="" />
					<span>下载</span>
				</div>
				<div class="gudBtnItem gudBtnItem1">
					<img src="@/assets/img/fenx (1).svg" class="img1" alt="" />
					<img src="@/assets/img/fenx.svg" class="img2" alt="" />
					<span>分享</span>
					<div class="erwB">
						<img :src="qrCodeImage" alt="" />
						<p>微信扫码分享</p>
					</div>
				</div>
			</div>
			<!-- <div class="meiWecL" v-if="type==3">
            <h2>
                {{perData.title}}
            </h2>
            <p class="meiWecLPs">
                <span>日期：{{ perData.releaseTime | momentYR('YYYY年MM月DD日') }}</span>
                <span>编写人：{{ perData.createNickName }}</span>
            </p>
            <div class="wzCont" v-html="perData.content"></div>
        </div> -->
			<div class="meiWecL meiWecL2" ref="meiWecL2" v-if="type == 2 || type == 4 || type == 1 || type == 3">
				<div class="meiWecL2-content">
					<myVideo
						ref="reVideo"
						v-if="viFlag && (perData.videoUrl || perData.videoResourceFileId)"
						:audioUrl="''"
						:audioResourceFileId="perData?.audioResourceFileId || 0"
						:coverImg="type == 1 || (type == 2 && flags != 1) || type == 3 || type == 4 ? '' : perData?.coverImg"
						:subtitlingUrl="perData.subtitlingUrl || ''"
						:videoUrl="perData.videoUrl"
						:videoResourceFileId="perData.videoResourceFileId"
						pyFlag="py"
					/>
					<myAudio
						ref="reAudio"
						v-if="(perData.audioUrl || perData?.audioResourceFileId) && audFlag"
						:title="perData.audioResourceFileName"
						:audioUrl="perData.audioUrl ? $httpUrl + perData.audioUrl : ''"
						:audioResourceFileId="perData?.audioResourceFileId || 0"
					/>
					<div class="meiWec2">
						<p v-html="perData.content"></p>
						<div class="meiWec2fot">
							<span>日期：{{ perData.releaseTime | momentYR('YYYY年MM月DD日') }}</span>
							<!-- <span>编写人：{{ perData.createNickName }}</span> -->
						</div>
						<div class="meiWec2Btn" v-if="flags == 1" @click="mwDaFlag = !mwDaFlag">查看答案</div>
						<div class="meiWec2Cont" v-if="flags == 1 && mwDaFlag && perData.contentOther" v-html="perData.contentOther"></div>
					</div>
				</div>
				<div class="meiWecL2-copyright" v-if="perData.showCopyrightFlag == 1">
					<p v-html="perData.copyright"  ></p>
				</div>
			</div>
			<!-- <div class="meiWecL meiWecL3" v-if="type==1">
            <myAudio :title="perData.audioResourceFileName" v-if="audFlag&&perData.audioUrl" :audioUrl="perData.audioUrl?$httpUrl+ perData.audioUrl:''"/>
            <div class="meiWecL3Cont">
                <div class="meiWecL3Ti">
                    {{perData.title}}
                </div>
                <div class="meiWecL3P">
                    <span>歌手：席琳·迪翁</span>
                    <span>作词：詹姆斯·霍纳  威尔·詹宁斯</span>
                </div>
                <p v-html="perData.content"></p>
                <div class="meiWecL3Fot">
                    <span>日期：{{ perData.releaseTime | momentYR('YYYY年MM月DD日') }}</span>
                    <span>编写人：{{ perData.createNickName }}</span>
                </div>
            </div>
            <div class="meiWecL3Nr" v-html="perData.content">
            </div>
        </div> -->
			<div class="meiWecL meiWecL5" v-if="type == 5">
				<div class="meiWecL5T">
					<span>日期：{{ perData.releaseTime | momentYR('YYYY年MM月DD日') }}</span>
					<!-- <span>编写人：{{ perData.createNickName }}</span> -->
				</div>
				<div class="meiWecL5B">
					预览内容
					<br />
					附件文件类型在线插件
				</div>
			</div>
			<div class="meiWecR" v-if="type != 5">
				<div class="meiWecTit">
					<img src="@/assets/img/rmen.svg" alt="" />
					<span>更多推荐</span>
				</div>
				<div class="meiWecCon" v-if="type == 4">
					<div class="meiWecItem meiWecItem2 supHove3" @click="resFn(item)" v-for="(item, index) in resList" :key="index">
						<h3 :title="item.title">{{ item.title }}</h3>
						<p v-html="$extractText($txtGs(item.content))" :title="$extractText($txtGs(item.content))"></p>
					</div>
				</div>
				<div class="meiWecCon" v-if="type != 4 && resList.length">
					<div class="meiWecItem supHove5" @click="resFn(item)" v-for="(item, index) in resList" :key="index">
						<div class="meiWecImg">
							<el-image :src="$imgUrl + item.coverImg" lazy></el-image>
						</div>
						<h3 :title="item.title">{{ item.title }}</h3>
						<p v-html="$extractText($txtGs(item.content))" :title="$extractText($txtGs(item.content))"></p>
					</div>
				</div>
				<div class="meiWecCon" v-if="!resList.length">
					<el-empty description="暂无推荐"></el-empty>
				</div>
			</div>
		</div>
		<foot />
	</div>
</template>

<script>
import foot from '@/components/foot/foot';
import crumbs from '@/components/hearder/crumbs';
import userHeader from '@/components/hearder/userHeader';
import myAudio from '@/components/pubComponents/myAudio';
import myVideo from '@/components/pubComponents/myVideo';
import { batchDownload } from '@/assets/js/xz';

export default {
	name: 'scDec',
	data() {
		return {
			type: 3, // 1美文 2视频 3音乐 4电影
			txt: '',
			viFlag: false,
			audFlag: false,
			a: ['个人中心'],
			fullscreenLoading: false,
			webpageResourceId: '',
			flags: '',
			perData: {},
			mwDaFlag: false,
			resList: [],
			ewmImg: '',
			crumFlag: false,
			ljList: [],
			qrCodeImage: ''
		};
	},
	components: {
		userHeader,
		crumbs,
		foot,
		myVideo,
		myAudio
	},
	methods: {
		hdBtn() {
			let item = '';
			this.ljList.pop();
			item = this.ljList[this.ljList.length - 1];
			if (!item) {
				this.$router.back();
				return;
			}
			this.txt = item.title;
			this.a.splice(this.a.length - 1, 1, item.title);
			this.viFlag = false;
			this.audFlag = false;
			window.scrollTo(0, 0);
			if (this.documentResourceId) {
				this.documentResourceId = item.documentResourceId;
				this.syInit();
			} else {
				this.webpageResourceId = item.webpageResourceId;
				this.resList = [];
				this.init();
			}
		},
		// xzBtns() {
		//     this.$refs['reAudio'].xzAudio()
		//     this.$refs['reVideo'].xzVideo()
		// },
		async xzBtns() {
			if (this.perData.limitsAuthority == 1) {
				if (JSON.parse(localStorage.getItem('useInfo')).authority == 0) {
					this.$message({
						message: '您现在是非会员用户，暂不能下载会员资源喔~',
						type: 'warning'
					});
					return;
				}
			}
			let id = '';
			let type = '';
			if (this.mutualAidResourceId) {
				id = this.mutualAidResourceId;
				type = 2;
			} else {
				id = this.documentResourceId;
				type = 1;
			}
			if (this.perData.videoResourceFileId || this.perData.audioResourceFileId) {
				let files = [];
				let arr = []
				if (this.perData.videoResourceFileId) {
					arr.push(this.perData.videoResourceFileId)
				}
				if (this.perData.audioResourceFileId) {
					arr.push(this.perData.audioResourceFileId)
				}
				if (this.perData.resourceFileId) {
					arr = arr.concat(String(this.perData.resourceFileId).split(','));
				}
				
					// 给数组循环赋值
					this.fullscreenLoading = true;
					let stop = false
					let newArr = arr.map(async (is, index) => {
						let res = await this.$http.get('api/app/common/getUrl', {
							params: {
								fileId: is,
								id: index == 0 ? id : '',
								type: index == 0 ? type : '',
								clientType: 1
							}
						}); // 年龄赋值等待
						console.log('res: ',res);
						if (res.code != 200) {
							stop = true
						}
						return {
							name: res.fileName,
							url: res.msg
						};
					});
					// Promise接收一个数组
					let newArrs = await Promise.all(newArr);
					console.log('stop: ',stop);
					this.fullscreenLoading = false;
					if (stop) {
						return
					}
					batchDownload(this.perData.title, newArrs);
				
			} else {
				this.$xzFn(
					{
						fileId: this.perData.resourceFileId,
						id,
						clientType: 1,
						type
					},
					(res) => {}
				);
			}
		},
		hqFn() {
			let { title } = this.perData;
			let str = JSON.stringify({
				title,
				content: ''
			});
			this.$router.push({
				path: 'xuqiuSq',
				query: {
					str
				}
			});
		},
		scFn(item) {
			if (this.type == 2 && this.flags == 1) {
				this.$scFn(
					{
						type: '2',
						assetsId: item.documentResourceId
					},
					item.isCollect,
					this.perList
				);
			} else {
				this.$scFn(
					{
						type: '1',
						assetsId: item.webpageResourceId
					},
					item.isCollect,
					this.perList
				);
			}
		},
		// resFn(item) {
		// 	let a = this.a.splice(this.a.length - 1, 1, item.title);
		// 	this.$router.push({
		// 		path: 'scDec',
		// 		query: {
		// 			type: this.type,
		// 			txt: item.title,
		// 			webpageResourceId: item.webpageResourceId,
		// 			crumFlag: 1,
		// 			tabFtxt: a
		// 		}
		// 	});
		// 	return
		// 	this.ljList.push(item);
		// 	this.txt = item.title;
		// 	this.a.splice(this.a.length - 1, 1, item.title);
		// 	this.viFlag = false;
		// 	this.audFlag = false;
		// 	window.scrollTo(0, 0);
		// 	if (this.documentResourceId) {
		// 		this.documentResourceId = item.documentResourceId;
		// 		this.syInit();
		// 	} else {
		// 		this.webpageResourceId = item.webpageResourceId;
		// 		this.resList = [];
		// 		this.init();
		// 	}
		// },
		resFn(item) {
			this.ljList.push(item);
			this.txt = item.title;
			this.a.splice(this.a.length - 1, 1, item.title);
			this.viFlag = false;
			this.audFlag = false;
			window.scrollTo(0, 0);
			if (this.documentResourceId) {
				this.documentResourceId = item.documentResourceId;
				this.syInit();
			} else {
				this.webpageResourceId = item.webpageResourceId;
				this.resList = [];
				this.init();
			}
		},
		async perList() {
			let str = '';
			if (this.documentResourceId) {
				str = `/api/app/yydDocumentResource/${this.documentResourceId}`;
			} else {
				str = `api/app/yydWebpageResource/${this.webpageResourceId}`;
			}
			this.fullscreenLoading = true;
			await this.$http.get(str).then((res) => {
				console.log(res);
				if (res.code == 200) {
					this.fullscreenLoading = false;
					this.perData = res.data;
					this.viFlag = true;
					this.audFlag = true;
				}
			});
		},
		init() {
			this.perList();
			setTimeout(() => {
				let num = this.$refs['meiWecL2'].offsetHeight;
				console.log(num, 8889);
				let nlnum = 0;
				if (this.type == 4) {
					nlnum = 86;
				} else {
					nlnum = 210;
				}
				let nums = Math.floor(num / nlnum);
				this.$http
					.get(`api/app/yydWebpageResource/list`, {
						params: {
							recommended: 1,
							type: this.type,
							pageNum: 1,
							pageSize: nums < 3 ? 3 : nums,
							webpageResourceId: this.webpageResourceId
						}
					})
					.then((res) => {
						if (res.code == 200) {
							this.fullscreenLoading = false;
							this.resList = res.rows;
						}
					});
			}, 900);
		},
		syInit() {
			this.perList();
			setTimeout(() => {
				let num = this.$refs['meiWecL2'].offsetHeight;
				console.log(num, 8890);
				let nlnum = 0;
				if (this.type == 4) {
					nlnum = 86;
				} else {
					nlnum = 210;
				}
				let nums = Math.floor(num / nlnum);
				this.$http
					.get(`api/app/yydDocumentResource/recommend/${this.documentResourceId}`, {
						params: {
							pageNum: 1,
							pageSize: nums < 3 ? 3 : nums
						}
					})
					.then((res) => {
						if (res.code == 200) {
							this.fullscreenLoading = false;
							this.resList = res.rows;
						}
					});
			}, 900);
		},
		ewmaFn() {
			let url = '';
			if (this.type == 3) {
				// 美文
				url = `pages/search/resources/meiwen/resource-detail?id=${this.webpageResourceId}&type=1`;
			}
			if (this.type == 2 && this.flags == '') {
				// 演讲
				url = `pages/search/resources/meiwen/resource-detail?id=${this.webpageResourceId}&type=2`;
			}
			if (this.type == 1) {
				// 歌曲
				url = `pages/search/resources/meiwen/resource-detail?id=${this.webpageResourceId}&type=3`;
			}
			if (this.type == 4) {
				// 电影
				url = `pages/search/resources/video/resource-detail?id=${this.webpageResourceId}`;
			}
			if (this.type == 2 && this.flags == 1) {
				// 双语新闻
				url = `pages/search/resources/meiwen/shuangyu-detail?id=${this.documentResourceId}`;
			}
			this.$http
				.get('api/app/common/getMiniProgramsCodes', {
					params: {
						url,
						clientType: '1'
					},
					responseType: 'blob'
				})
				.then((res) => {
					if (res) {
						const blob = new Blob([res], { type: 'image/png' });
						this.qrCodeImage = URL.createObjectURL(blob);
					}
				});
		}
	},
	mounted() {
		const { type, txt, flags, webpageResourceId, tabFtxt, documentResourceId, crumFlag } = this.$route.query;
		if (tabFtxt) {
			this.a = typeof tabFtxt == 'string' ? [tabFtxt] : [...tabFtxt];
		}
		this.webpageResourceId = webpageResourceId;
		this.documentResourceId = documentResourceId;
		this.type = type || 3;
		this.txt = txt || '';
		this.flags = flags || '';
		if (txt.includes('~')) {
			this.a.push(...txt?.split('~'));
		} else {
			this.a.push(txt);
		}
		if (this.documentResourceId) {
			this.ljList.push({
				title: txt,
				documentResourceId
			});
			this.syInit();
		} else {
			this.ljList.push({
				title: txt,
				webpageResourceId
			});
			this.init();
		}
		this.ewmaFn();
		if (crumFlag) {
			this.crumFlag = true;
		}
	}
};
</script>
<style lang="scss" scoped>
.meiWecBox {
	width: 1200px;
	margin: 0 auto 10px;
	display: flex;
	position: relative;
	.gudBtns {
		position: absolute;
		top: 0;
		left: -65px;
		width: 58px;
		.gudBtnItem {
			width: 58px;
			height: 58px;
			margin-bottom: 4px;
			background: #fff;
			border-radius: 4px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			color: #8f9190;
			font-size: 12px;
			position: relative;
			cursor: pointer;
			img {
				margin-bottom: 3px;
			}
			.img2 {
				display: none;
			}
			&:hover {
				.img1 {
					display: none;
				}
				.img2 {
					display: block;
				}
				.erwB {
					display: block;
				}
			}
			.erwB {
				position: absolute;
				top: 0;
				left: 65px;
				padding: 9px 12px 0;
				z-index: 99999;
				background: #fff;
				border-radius: 15px;
				display: none;
				box-shadow: 0px 6px 15px 0px rgba(0, 0, 0, 0.16);
				img {
					width: 145px;
					height: 145px;
					margin: 0;
					vertical-align: bottom;
				}
				p {
					height: 30px;
					line-height: 30px;
					font-size: 12px;
					color: #000000;
					text-align: center;
				}
			}
		}
		.gudBtnItem1 {
			&:hover {
				color: #1d7b3a;
			}
		}
		.activeBtn {
			color: #1d7b3a;
		}
	}
	.meiWecL {
		width: calc(1200px - 321px - 10px);
		margin-right: 10px;
		background: #fff;
		border-radius: 6px;
		padding: 34px 38px 50px;
		h2 {
			color: #000000;
			font-size: 18px;
			font-weight: bold;
			margin-bottom: 23px;
			text-align: center;
		}

		p {
			color: #8f9190;
			font-size: 12px;
			text-align: center;
			margin-bottom: 49px;
			span {
				margin-right: 29px;
				&:last-of-type {
					margin-right: 0;
				}
			}
		}
		.meiWecLPs {
			padding-bottom: 33px;
			border-bottom: 1px solid #f8f8f8;
			margin-bottom: 15px;
		}
		.wzCont {
			font-size: 14px;
			color: #000000;
			line-height: 1.5;
			text-indent: 2em;
			::v-deep img {
				width: 100%;
			}
		}
	}
	.meiWecL2 {
		display: flex;
		flex-direction: column;
		padding: 0;
		background: none;
		border-radius: 0;
		.meiWecL2-content {
			flex: 1;
			padding: 16px 19px 68px;
			position: relative;
			background: #fff;
			border-radius: 6px;
			.meiWec2 {
				margin: 34px 0 0;
				::v-deep img {
					max-width: 100% !important;
				}
				p {
					color: #000000;
					font-size: 14px;
					text-align: left;
					line-height: 2;
					margin-bottom: 24px;
				}
				.meiWec2fot {
					display: flex;
					span {
						color: #8f9190;
						font-size: 12px;
						margin-right: 29px;
					}
				}
				.meiWec2Btn {
					width: 84px;
					height: 36px;
					background: #1d7b3a;
					border-radius: 7px;
					margin-top: 20px;
					display: flex;
					align-items: center;
					justify-content: center;
					cursor: pointer;
					font-size: 14px;
					color: #ffffff;
				}
				.meiWec2Cont {
					margin-top: 15px;
					font-size: 14px;
					line-height: 1;
				}
			}
		}
		.meiWecL2-copyright {
			margin-top: 10px;
			padding: 16px 19px;
			background: #fff;
			border-radius: 6px;
			::v-deep img {
				max-width: 100% !important;
			}
			p {
				color: #000000;
				font-size: 14px;
				text-align: left;
				line-height: 2;
				margin-bottom: 0;
			}
		}
	}
	.meiWecL5 {
		padding: 0 21px 20px;
		.meiWecL5T {
			height: 64px;
			display: flex;
			align-items: center;
			color: #8f9190;
			font-size: 12px;
			span {
				margin-right: 29px;
			}
		}
		.meiWecL5B {
			height: calc(100% - 64px);
			display: flex;
			justify-content: center;
			align-items: center;
			border-radius: 13px;
			background: #f3f4f7;
			color: #6b6e75;
			font-size: 14px;
			text-align: center;
			line-height: 1.5;
		}
	}
	.meiWecL3 {
		padding: 18px 17px 42px 21px;
		width: calc(100% - 309px);
		.meiWecL3Cont {
			margin-top: 20px;
			::v-deep img {
				width: 100% !important;
			}
			.meiWecL3Ti {
				color: #000000;
				font-size: 18px;
				margin-bottom: 15px;
			}
			.meiWecL3P {
				font-size: 14px;
				color: #3d3d3d;
				margin-bottom: 8px;
				span {
					margin-right: 40px;
				}
			}
			p {
				font-size: 12px;
				line-height: 2;
				color: #8f9190;
				margin-bottom: 15px;
				text-align: left;
			}
			.meiWecL3Fot {
				display: flex;
				font-size: 12px;
				color: #8f9190;
				margin-bottom: 41px;
				span {
					margin-right: 22px;
				}
			}
		}
		.meiWecL3Nr {
			font-size: 16px;
			color: #000000;
			line-height: 3;
		}
	}

	.meiWecR {
		width: 299px;
		background: #fff;
		border-radius: 6px;
		padding: 0 10px 0 12px;
		box-sizing: border-box;
		.meiWecTit {
			height: 67px;
			display: flex;
			align-items: center;
			border-bottom: 1px solid #f8f8f8;
			font-size: 18px;
			font-weight: bold;
			img {
				width: 30px;
				height: 30px;
				margin-right: 7px;
			}
		}
		.meiWecCon {
			padding: 20px 12px;
			.meiWecItem {
				margin-bottom: 28px;
				border-bottom: 1px solid #f8f8f8;
				cursor: pointer;
				&:last-of-type {
					margin-bottom: 0;
					border-bottom: none;
				}
				.meiWecImg {
					height: 143px;
					margin-bottom: 12px;
					img {
						border-radius: 12px;
						width: 100%;
						height: 100%;
						object-fit: cover;
					}
				}
				h3 {
					font-size: 16px;
					color: #000000;
					margin-bottom: 10px;
					font-weight: bold;
					overflow: hidden; /* 确保超出容器的内容被裁剪 */
					white-space: nowrap; /* 确保文本在一行内显示 */
					text-overflow: ellipsis;
				}
				p {
					font-size: 14px;
					color: #8f9190;
					line-height: 1.5;
					overflow: hidden; /* 确保超出容器的内容被裁剪 */
					white-space: nowrap; /* 确保文本在一行内显示 */
					text-overflow: ellipsis; /* 超出部分显示省略号 */
				}
			}
			.meiWecItem2 {
				padding: 16px 5px 18px;
				margin: 0;
				&:first-of-type {
					padding-top: 0;
				}
			}
		}
	}
	.meiWecR5 {
		background: rgb(243, 244, 247);
		padding: 0;

		.meiWecRBox {
			background: #fff;
			margin-bottom: 10px;
			padding: 0 13px 15px;
			border-radius: 6px;
			&:last-of-type {
				margin-bottom: 0;
			}
		}
		.meiWecTit5 {
			height: 60px;
			border: none;
			padding: 0 2px;
		}
		.meiWecRBoxC {
			margin-top: 5px;
			.meiWecRCItem {
				padding: 16px 3px;
				border-bottom: 1px solid #f8f8f8;
				display: flex;
				> img {
					width: 50px;
					height: 50px;
					margin-right: 7px;
					border-radius: 6px;
					background: red;
				}
				.meiWecRCItemR {
					flex: 1;
					p {
						overflow: hidden; /* 确保超出容器的内容被裁剪 */
						white-space: nowrap; /* 确保文本在一行内显示 */
						text-overflow: ellipsis; /* 超出部分显示省略号 */
						font-size: 14px;
						color: #000000;
						font-weight: bold;
						margin-bottom: 10px;
					}
					.meiWecRCItemRF {
						display: flex;
						justify-content: space-between;
						> div {
							display: flex;
							align-items: center;
							font-size: 12px;
							img {
								margin-right: 5px;
							}
						}
						.meiWecFjVip {
							color: #93571c;
							img {
								width: 15px;
								height: 13px;
							}
						}
						.meiWecFjXz {
							color: #8f9190;
							img {
								width: 12px;
								height: 13px;
							}
						}
					}
				}
				&:first-of-type {
					padding-top: 0;
				}
				&:last-of-type {
					border-bottom: none;
				}
			}
		}
		.meiWecFjBot {
			display: flex;
			justify-content: space-between;
			font-size: 12px;
			align-items: center;
			.meiWecFjXz {
				font-size: 12px;
				color: #8f9190;
				img {
					margin-right: 4px;
					width: 12px;
					height: 13px;
				}
			}
			.meiWecFjVip {
				width: 82px;
				height: 23px;
				background: linear-gradient(90deg, #fde6d1 0%, #fdd7b3 100%);
				border-radius: 4px;
				display: flex;
				justify-content: center;
				align-items: center;
				font-size: 12px;
				color: #93571c;
				img {
					width: 14px;
					height: 13px;
					margin-right: 5px;
				}
			}
		}
		.meiWecFjFot {
			height: 121px;
			display: flex;
			padding: 0 15px;
			justify-content: space-between;
			align-items: center;
			.meiWecFjItem {
				text-align: center;
				cursor: pointer;
				img {
					width: 44px;
					height: 44px;
					margin-bottom: 11px;
					vertical-align: bottom;
				}
				p {
					color: #000000;
					font-size: 14px;
				}
			}
		}
		.meiWecFj {
			padding: 14px 20px 15px 15px;
			background: #f3f4f7;
			border-radius: 7px;
			p {
				color: #000000;
				font-size: 14px;
				font-weight: bold;
				margin-bottom: 12px;
				line-height: 1.5;
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
				overflow: hidden;
				text-overflow: ellipsis;
			}
		}
	}
}
</style>
